<div *ngIf="pageLayoutBody$ | async as pageBody">
  <section *ngFor="let row of pageBody?.rows; index as i" [ngClass]="row.styleClass">
    <custom-dot-cms-row [deviceType]="deviceType$ | async" [columns]="row.columns" class="row"></custom-dot-cms-row>
  </section>
</div>
